/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {HELP_LINK, SOMETHING_WENT_WRONG} from "../../constants/constants";
import React, {useEffect} from "react";
import {ExdsAlert} from "@exds/feedback";
import './Alert.scss';
import {sanitizedHtml} from "../../utils/utils";
import parse from 'html-react-parser';
import {addExitEvent} from "../AdobeAnalytics/AdobeAnalytics";

export default function Alert({errorMessage, correlationId, loadAA, pageName, sid}) {
  const errorContent = errorMessage || SOMETHING_WENT_WRONG;
  useEffect(() => {
    const helpLink = document.querySelector('.help-link');
    if(helpLink) {
      helpLink.addEventListener('click', () => {
        if(loadAA) {
          addExitEvent(pageName, sid, HELP_LINK, 'Link', 'Ask JPMC', 'Alert');
        }
      });
    }
  }, [errorContent]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className='alert-container'>
    <ExdsAlert
      fullWidth
      size="medium"
      text={parse(sanitizedHtml(errorContent || SOMETHING_WENT_WRONG))}
      variant="error"
      headingLevel={0}
      className='alert-message'
      secondaryText={correlationId ? `Correlation ID: ${correlationId}` : ''}
    />
  </div>;
}
